import React, { useEffect, useState } from 'react'
import { HiUserGroup } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import { MdAlternateEmail, MdEmail } from 'react-icons/md';
import LoaderBootStrap from '../../../components/admin/dasboard/LoaderBootStrap'
import { BsPhoneVibrate } from 'react-icons/bs'
import { FaUserCircle } from 'react-icons/fa'
import { LoadAllEmail } from '../../../actions/Emails/EmailsAction'

const ListEmailPage = () => {
  const navigate = useNavigate('');
  const [idMessage, setidMessage] = useState('');
  const [name, setname] = useState('');
  const [email, setemail] = useState('');
  const [subject, setsubject] = useState("");
  const [telephone, settelephone] = useState('');
  const [content, setcontent] = useState("");


  const [messagelist, setmessagelist] = useState([]);

  useEffect(() => {
    LoadAllEmail(setmessagelist);
  }, [])
  // Recherche



  return (
    <div class='w-full'>
      <div class='py-1 my-2 mx-1 bg-cyan-700 text-white px-2 py-2 rounded-lg flex justify-center '>
        <h2 class=' text-white flex space-x-3 items-center text-xl'>
          <MdAlternateEmail class='text-white w-8 h-8' />
          Email reçus
        </h2>
      </div>
      <div class='w-full  rounded-lg bg-white px-2 h-[600px] overflow-y-scroll '>
        <div class='w-full flex justify-between py-3 '>
          {/* Barre de recherche */}
          <div class='w-full input-group rounded-lg w-[400px]'>
            <input
              type='text'
              class='form-control  w-full'
              placeholder='rechercher...'
            />
            <button class='btn btn-primary px-4'>
              <i class='bi bi-search'></i>
            </button>
          </div>
          {/* Lien Ajouter */}
          <div>

          </div>
          {/* Modal Add User */}
        </div>
        <div class='w-full flex space-x-2'>
          <div class='w-full'>
            <div class='w-full bg-white py-4 md:py-7 px-4 md:px-8 xl:px-10'>
              <div class='w-full mt-2 overflow-x-auto'>
                {messagelist && messagelist.length > 0 ? (
                  <table class='w-full whitespace-nowrap'>
                    <thead>
                      <tr
                        tabindex='0'
                        class='w-full focus:outline-none my-2 py-2 h-11 border border-gray-100 rounded'
                      >
                       
                        <th class='pl-4 border-l py-1'>Email</th>
                        <th class='pl-4 border-l py-1 space-x-2'>action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {messagelist.map(item => {
                        return (
                          <tr
                            tabindex='0'
                            class='w-full focus:outline-none hover:bg-gray-200 my-2 py-2 h-11 border border-gray-100 rounded'
                          >
                            <td class='pl-4'>{item.email}</td>
                            <td class='pl-4 space-x-2'>
                              <button
                                type='btn'
                                class='  text-lime-900 hover:underline px-1 px-2 py-1'
                                data-bs-toggle='modal'
                                data-bs-target='#updateUser'
                                onClick={() => {
                                  setidMessage(item._id);
                                  setname(item.name);
                                  settelephone(item.telephone);
                                  setemail(item.email)
                                  setcontent(item.content);
                                  setsubject(item.subject);
                                }}
                              >
                                voire
                              </button>

                              {
                                /*
                                <button
                                type='btn'
                                class='  text-red-900 hover:underline px-1 px-2 py-1'
                                data-bs-toggle='modal'
                                data-bs-target='#hideUser'
                              >
                                bloquer
                              </button>
                                */
                              }

                              {/* Modal view */}
                              <div
                                class=' modal fade containter '
                                id='updateUser'
                                tabIndex='-2'
                                aria-labelledby='exampleModalLabel'
                                aria-hidden='true'
                              >
                                <div class='modal-dialog'>
                                  <div class='modal-content rounded-0'>
                                    <div class='modal-header relative'>
                                      <h6
                                        class=' modal-title  text-primary text-uppercase display-7 text-uppercase mb-0'
                                        id='exampleModalLabel'
                                        style={{ maxWidth: '600px' }}
                                      >
                                        Details du message
                                      </h6>
                                      <button
                                        type='button'
                                        class='absolute top-3 right-4 btn btn-close text-2xl '
                                        data-bs-dismiss='modal'
                                        aria-label='Close'
                                      >
                                        X
                                      </button>
                                    </div>
                                    <div class='modal-body container-fluid w-full flex justify-start'>
                                      <div class='w-full flex justify-start '>
                                        <div class='col-lg-12'>
                                          <div>
                                            <div class='w-full row g-3'>
                                              <div class='w-full bg-gray-400 text-white flex flex-col justify-start'>
                                                <label className="translatable flex flex-wrap space-x-3"><span><FaUserCircle className="translatable h-6 w-6" /></span><span>{name}</span></label>
                                                <label className="translatable flex flex-wrap space-x-3"><span><MdEmail className="translatable h-6 w-6" /></span><span>{email}</span></label>
                                                <label className="translatable flex flex-wrap space-x-3"><span><BsPhoneVibrate className="translatable h-6 w-6" /></span><span>{telephone}</span></label>
                                              </div>
                                              <div class='w-full bg-gray-700  col-12 flex justify-start py-3'>
                                                <p className="translatable text-left bg-gray-700 p-2 text-white">{content}</p>
                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Modal Access */}
                              <form
                                class=' modal fade '
                                id='showUser'
                                tabIndex='-2'
                                aria-labelledby='exampleModalLabel'
                                aria-hidden='true'

                              >
                                <div class='modal-dialog'>
                                  <div class='modal-content rounded-0'>
                                    <div class='modal-header relative'>
                                      <h6
                                        class=' modal-title  text-success text-uppercase display-7 text-uppercase mb-0'
                                        id='exampleModalLabel'
                                        style={{ maxWidth: '600px' }}
                                      >
                                        Débloquer cet membre
                                      </h6>
                                      <button
                                        type='button'
                                        class='absolute top-3 right-4 btn btn-close text-2xl '
                                        data-bs-dismiss='modal'
                                        aria-label='Close'
                                      >
                                        X
                                      </button>
                                    </div>
                                    <div class='modal-body container flex justify-center'>
                                      <div class='flex justify-center row g-8'>
                                        <div class='col-lg-9'>
                                          <form class='w-full flex flex-col'>
                                            <div class='flex py-2 px-3 items-center justify-center'>
                                              <h2 class='text-xl'>
                                                Nom complet
                                              </h2>
                                            </div>
                                            <div class='flex flex-row justify-between space-x-2'>
                                              <div class='col-12'>
                                                <button
                                                  class='btn btn-outline-success w-100 py-2'
                                                  type='submit'
                                                >
                                                  Débloquer
                                                </button>
                                              </div>
                                              <div class='col-12'>
                                                <button
                                                  type='button'
                                                  class='btn btn-light w-100 py-1'
                                                >
                                                  annuler
                                                </button>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                              {/* Modal Delete */}
                              <form
                                class=' modal fade '
                                id='hideUser'
                                tabIndex='-2'
                                aria-labelledby='exampleModalLabel'
                                aria-hidden='true'

                              >
                                <div class='modal-dialog'>
                                  <div class='modal-content rounded-0'>
                                    <div class='modal-header relative'>
                                      <h6
                                        class=' modal-title  text-danger text-uppercase display-7 text-uppercase mb-0'
                                        id='exampleModalLabel'
                                        style={{ maxWidth: '600px' }}
                                      >
                                        Traiter ce message
                                      </h6>
                                      <button
                                        type='button'
                                        class='absolute top-3 right-4 btn btn-close text-2xl '
                                        data-bs-dismiss='modal'
                                        aria-label='Close'
                                      >
                                        X
                                      </button>
                                    </div>
                                    <div class='modal-body container flex justify-center'>
                                      <div class='flex justify-center row g-8'>
                                        <div class='col-lg-9'>
                                          <form class='w-full flex flex-col'>
                                            <div class='flex py-2 px-3 items-center justify-center'>
                                              <h2 class='text-xl'>
                                                Nom complet
                                              </h2>
                                            </div>
                                            <div class='flex flex-row justify-between space-x-2'>
                                              <div class='col-12'>
                                                <button
                                                  class='btn btn-outline-danger w-100 py-2'
                                                  type='submit'
                                                >
                                                  Bloquer
                                                </button>
                                              </div>
                                              <div class='col-12'>
                                                <button class='btn btn-light w-100 py-1'>
                                                  annuler
                                                </button>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                ) : (
                  <LoaderBootStrap />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListEmailPage;
